import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { faqs } from '../data/mockData';
import SafeIcon from '../common/SafeIcon';
import { FiPlus, FiMinus, FiMessageSquare } from 'react-icons/fi';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="max-w-3xl mx-auto space-y-8">
      <div className="text-center space-y-3">
        <h1 className="text-3xl font-bold text-slate-100">Support & FAQ</h1>
        <p className="text-slate-400">Everything you need to know about navigating the ComplianceCloud platform.</p>
      </div>

      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div key={index} className="bg-slate-800/40 border border-slate-700/50 rounded-xl overflow-hidden backdrop-blur-sm">
            <button
              onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
              className="w-full flex items-center justify-between p-5 text-left hover:bg-slate-800 transition-colors"
            >
              <span className="font-semibold text-slate-200">{faq.q}</span>
              <SafeIcon icon={openIndex === index ? FiMinus : FiPlus} className={`text-amber-500 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} />
            </button>
            <AnimatePresence>
              {openIndex === index && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: 'auto', opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.2 }}
                >
                  <div className="p-5 pt-0 text-slate-400 border-t border-slate-700/30 leading-relaxed text-sm">
                    {faq.a}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>

      <div className="bg-slate-900 border border-slate-700 p-8 rounded-2xl text-center space-y-4">
        <div className="w-12 h-12 bg-amber-500/20 rounded-full flex items-center justify-center text-amber-500 mx-auto">
          <SafeIcon icon={FiMessageSquare} />
        </div>
        <h3 className="text-xl font-bold text-slate-200">Still have questions?</h3>
        <p className="text-slate-400 text-sm">Our support team (available via DigLab & LingLink channels) is ready to help you optimize your compliance flow.</p>
        <button className="bg-slate-800 text-slate-200 px-6 py-2 rounded-lg border border-slate-700 hover:bg-slate-700 transition-all font-medium">
          Contact Support
        </button>
      </div>
    </div>
  );
};

export default FAQ;